import { createFeatureSelector, createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import { ActionsEnum, UpdateRenewalInfo } from './billing-data.actions';
import { RenewalInfo } from './models/renewal-info.model';

// feature name
export const FEATURE_NAME = 'billing-data';

// state definition
export interface IState {
  renewalInfo: RenewalInfo;
}

// initial state
export const initialState: IState = {
  renewalInfo: void 0,
};

// reducer
const reducerFn = handleActions(
  {
    [ActionsEnum.UPDATE_RENEWAL_INFO]: function (
      state: IState,
      { payload }: UpdateRenewalInfo
    ): IState {
      return {
        ...state,
        renewalInfo: payload.renewalInfo,
      };
    },
  } as any,
  initialState
);

export function reducer(state: IState = initialState, action: any) {
  return reducerFn(state, action);
}

// selectors
const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export const getRenewalInfo = createSelector(
  selectFeature,
  (state: IState) => state.renewalInfo
);
